module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_unfinished-a884f77a9565980ead380dbb0baa91fb.png";